import { getCsrfToken } from './csrf';

type FetchOptions = RequestInit & {
  headers?: HeadersInit;
};

export const apiFetch = async (url: string, options: FetchOptions = {}): Promise<Response> => {
  const { headers = {}, ...restOptions } = options;

  const defaultHeaders: HeadersInit = {
    'Content-Type': 'application/json',
  };

  const csrfToken = getCsrfToken();
  if (csrfToken && shouldIncludeCsrfToken(options.method)) {
    defaultHeaders['X-CSRF-Token'] = csrfToken;
  }

  return fetch(url, {
    ...restOptions,
    headers: {
      ...defaultHeaders,
      ...headers,
    },
  });
};

function shouldIncludeCsrfToken(method: string | undefined): boolean {
  if (!method) return false;
  return ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method.toUpperCase());
}

export const apiJson = async <T = unknown>(url: string, options: FetchOptions = {}): Promise<T> => {
  const response = await apiFetch(url, options);

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Request failed' }));
    throw new Error(error.message || `HTTP ${response.status}`);
  }

  return response.json();
};